import store from "../../store";

const REPORT_EXPORT_CSS = `
  body {
    margin: 0;
    padding: 12px;
    font-family: Roboto, Helvetica, Arial, sans-serif;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.87);
    background: #fff;
  }
  .table-total {
    width: 100%;
    border-spacing: 0;
    border-collapse: collapse;
  }
  .table-header {
    text-align: center;
    font-size: 0.875rem;
    font-weight: 600;
    line-height: 1.43;
    letter-spacing: 0.01071em;
    border-bottom: 1px solid rgb(224, 224, 224);
    padding: 3px 8px;
  }
  .group-row-data,
  .loaicuoc-row-data,
  .total-row {
    text-align: right;
    font-size: 0.875rem;
    line-height: 1.43;
    letter-spacing: 0.01071em;
    border-bottom: 1px solid rgb(224, 224, 224);
    padding: 3px 8px;
  }
  .group-row-data { font-weight: 500; }
  .loaicuoc-row-data { font-weight: 100; }
  .total-row { font-weight: 500; }
  .loaicuoc { text-align: left; }
  .trung { color: red; }
  .basic-lailo {
    padding: 6px 8px;
    font-weight: 700;
    border-bottom: 1px solid rgb(224, 224, 224);
  }
  .basic-lailo.lai { color: #0b7a0b; }
  .basic-lailo.lo { color: #d32f2f; }
  .details-row {
    width: 100%;
    display: grid;
    grid-template-columns: 25% 20% 20% 20% 15%;
    font-size: 0.875rem;
  }
  .details-header,
  .table-cell {
    padding: 3px 0;
  }
  .details-header { font-weight: 700; }
  .details-header.right,
  .table-cell.right {
    text-align: right;
  }
  pre {
    white-space: pre-wrap;
    word-break: break-word;
    margin: 0;
  }
  .report-site-url {
    margin: 0 0 10px 0;
    padding: 8px 10px;
    border: 1px solid #ffcc80;
    border-radius: 6px;
    background: #fff8e1;
    font-size: 13px;
    font-weight: 700;
    color: #ef6c00;
    word-break: break-all;
  }
  .report-site-url a {
    color: #d84315;
    text-decoration: underline;
    font-weight: 700;
  }
  .report-site-url a:hover {
    color: #bf360c;
  }
  .report-attention {
    margin-left: 8px;
    color: #d50000;
    font-weight: 800;
    text-shadow: 0 0 0 rgba(213, 0, 0, 0);
    animation: report-blink 0.9s ease-in-out infinite;
  }
  @keyframes report-blink {
    0%, 100% {
      opacity: 1;
      color: #d50000;
      text-shadow: 0 0 0 rgba(213, 0, 0, 0);
    }
    50% {
      opacity: 1;
      color: #ff1744;
      text-shadow: 0 0 8px rgba(255, 23, 68, 0.55);
    }
  }
  .report-message-meta {
    margin: 0 0 10px 0;
    padding: 8px 10px;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    background: #fafafa;
    font-size: 13px;
    line-height: 1.45;
  }
  .report-message-meta .meta-line {
    margin: 0 0 4px 0;
  }
  .report-message-meta .meta-line:last-child {
    margin-bottom: 0;
  }
  .report-message-body {
    margin-top: 6px;
    white-space: pre-wrap;
    word-break: break-word;
    max-height: 30vh;
    overflow-y: auto;
    padding-right: 4px;
  }
  .report-section {
    margin-bottom: 14px;
    padding-bottom: 10px;
    border-bottom: 1px dashed #e0e0e0;
  }
  .report-section:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
    border-bottom: none;
  }
`;

export function escapeHtml(value: string): string {
  return value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function formatDateVN(value: any): string {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return String(value);
  }
  return `${`${date.getDate()}`.padStart(2, "0")}/${`${date.getMonth() + 1}`.padStart(2, "0")}/${date.getFullYear()}`;
}

function formatTimeVN(value: any): string {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return "";
  }
  return `${`${date.getHours()}`.padStart(2, "0")}:${`${date.getMinutes()}`.padStart(2, "0")}`;
}

function getCurrentTimeVN(): string {
  const now = new Date();
  return `${`${now.getHours()}`.padStart(2, "0")}:${`${now.getMinutes()}`.padStart(2, "0")}`;
}

export function buildReportMessageMetaHtml(message: any): string {
  if (!message) return "";
  const ngay = formatDateVN(message.date);
  const totalReport: any[] = store.getState().basicReport.totalReport || [];
  const contactNameFromMessage0 = totalReport.length > 0 ? totalReport[0]?.contactName : "";
  const isTotalMessage = (message.messageId ?? 0) == 0;
  const bodyText = isTotalMessage
    ? (message.viewType == "group" ? message.body : "CHI TIẾT BỘ SỐ:" + (message.mienText || ""))
    : message.body;
  const body = escapeHtml(String(bodyText || ""));
  const gioRaw = isTotalMessage ? getCurrentTimeVN() : (message.time || formatTimeVN(message.date));
  const gio = escapeHtml(String(gioRaw));
  const contactName = escapeHtml(String(contactNameFromMessage0 || message.contactName || ""));
  const bodyLabelHtml = isTotalMessage
    ? ""
    : `<div class="meta-line"><strong>Nội dung tin nhắn:</strong></div>`;
  return `<div class="report-message-meta">
    <div class="meta-line"><strong>Ngày:</strong> ${escapeHtml(ngay)}${gio ? ` - <strong>Giờ:</strong> ${gio}` : ""}</div>
    <div class="meta-line"><strong>Khách hàng:</strong> ${contactName}</div>
    ${bodyLabelHtml}
    <div class="report-message-body">${body}</div>
  </div>`;
}

export function buildReportHtmlDocument(
  bodyHtml: string,
  title: string = "Report",
  messageMetaHtml: string = "",
): string {
  const siteUrl = typeof window !== "undefined" ? window.location.href : "";
  const siteUrlHtml = siteUrl
    ? `<div class="report-site-url">Nguồn: <a href="${escapeHtml(siteUrl)}" target="_blank" rel="noopener noreferrer">${escapeHtml(siteUrl)}</a><span class="report-attention">Đỉnh cao công nghệ</span></div>`
    : "";
  return `<!doctype html>
<html lang="vi">
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <title>${title}</title>
    <style>${REPORT_EXPORT_CSS}</style>
  </head>
  <body>
    ${siteUrlHtml}
    ${messageMetaHtml}
    ${bodyHtml}
  </body>
</html>`;
}
